import {
  TIMELINE_VIEW_SOURCE_DATA_RELEVANT_VIEW_SETTINGS,
  TimelineViewSettings,
} from '@ardoq/timeline2024';

type SourceDataArgs = { viewSettings: TimelineViewSettings };

export const isGraphRelevant = <Args extends SourceDataArgs>(
  previous: Args | null,
  next: Args
): boolean => {
  if (!previous) {
    return true;
  }
  const hasGraphRelevantViewSettingsChange =
    TIMELINE_VIEW_SOURCE_DATA_RELEVANT_VIEW_SETTINGS.some(
      key => previous.viewSettings[key] !== next.viewSettings[key]
    );
  const hasGraphInputChange = (Object.keys(next) as (keyof Args)[]).some(
    key => key !== 'viewSettings' && previous[key] !== next[key]
  );
  return hasGraphRelevantViewSettingsChange || hasGraphInputChange;
};
